export enum AccountTypes {
  admin = "ADMIN",
  company = "COMPANY"
}